import { GetParamsData, PostDepositDefaultDate } from '$Deposits/lib/LibCommonData'
import { SetDepositNextStep, SetDepositSuccessPage, PostConfirmStep } from './DepositAction'
import { moneyReg } from '$Deposits/lib/Reg';
import { PayApiPort } from '../../Api'
import moment from 'moment'

import {
    GetMethodsActive,
    GetMethodCodeActive,
    GetMethodsDetails,
    GetDepositBankActive,
    GetDepositMemberBanksActive,
    GetDepositPayments,
    GetDepositMoneyStatus,
    GetDepositOldBankSixNumberStatus,
    GetDepositCardNumber_CC,
    GetDepositDateSelect,
    GetDepositTimeSelect,
    GetDepositCardPIN_CC,
    GetUploadFileList,
    GetDepositAccountByAmountValues
} from './DepositUpdate'

function toastErrMeaasge(data, flag) {
    const { toastTip } = GetParamsData() || {}
    let errors = data?.errors
    if (Array.isArray(errors) && errors.length) {
        let msg = errors[0]?.description?.includes('P10') ? (errors[0]?.message || 'ไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง') : (errors[0]?.description || errors[0]?.message || 'ไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง')
        if (flag) {
            return msg
        } else {
            toastTip.error(msg, 2)
        }
    }
}

//LB提交存款
export const SetDepositPayments_LB = (data = {}) => {
    return async (dispatch, getState) => {
        const {fileName, fileBytes} = GetUploadFileList() || {}
        const { money } = GetDepositMoneyStatus()
        const methodCode = GetMethodCodeActive() || 'DEFAULT'
        const depositAccount = (methodCode !== "UniqueAmt" ?  GetDepositAccountByAmountValues() : GetDepositBankActive()) || {}
        const { accountNo = '', enBankName = '', province = '', city = '', branch = '' } = depositAccount
        const { bankName, accountNumber, accountHolderName } = GetDepositMemberBanksActive() || {}
        const { methods } = GetMethodsActive()
        const { language, mgmtRefNo, swiftCode, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        const { transferTypes = [] } = GetMethodsDetails() || {}
        // CXPC-1700: 優先檢查 isAutoAssign=true, depositingBankName傳空值
        const { isAutoAssign = false } = GetMethodsDetails() && GetMethodsDetails()['setting'] || {}

        // const enDepositingBankName = isAutoAssign ? '' : methodCode === "UniqueAmt" ? (enBankName || '') : ''

        toastTip.loading(fileName? `กำลังอัพโหลดไฟล์\nกรุณารอสักครู่...`: 'กำลังโหลด…');
        
        let postData = {
            // 收款---
            depositingBankAcctNum: methodCode === "UniqueAmt" ? "" : (accountNo && accountNo.slice(-6) || ''),

            // depositingBankName: enDepositingBankName,

            province: province || '',
            city: city || '',
            branch: branch || '',
            // 收款----

            // 付款---
            bankName: bankName || '',
            accountNumber: accountNumber || '',
            accountHolderName: accountHolderName || '',
            // 付款---
            methodCode: methodCode,
            amount: money,
            paymentMethod: methods,
            depositingWallet: depositingWallet,
            offlineDepositDate: `${GetDepositDateSelect()} ${methodCode === "UniqueAmt" ? moment().format('HH:mm') : GetDepositTimeSelect()}`,
            language: language,
            charges: 0,
            transactionType: 'Deposit',
            domainName: domainName || '',
            isMobile: false,
            isSmallSet: false,
            refNo: '0',
            swiftCode: swiftCode,
            mgmtRefNo: mgmtRefNo,
            transferType: transferTypes[0] || '',
            offlineRefNo: '0',
            cardName: '',
            cardNumber: '',
            cardPIN: '',
            cardExpiryDate: '',
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            bonusCoupon: '',
            couponText: '',
            successUrl: successUrl,
            fileBytes: fileBytes || '',
            fileName: fileName || '',
            secondStepModel: null,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };
        if (!isAutoAssign) {
            const bankNameValue = methodCode === "UniqueAmt" ? (enBankName || '') : '';
            if (bankNameValue) {
                postData.depositingBankName = bankNameValue;
            }
        }

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    fileName && toastTip.success("อัปโหลดสลิปแล้ว", 3)
                    if(methodCode == 'UniqueAmt') {
                        //UniqueAmt渠道处理
                        // dispatch(SetDepositNextStep(true))//提交成功，下一步
                    } else {
                        // dispatch(PostConfirmStep(res.result || {}))
                        dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                        dispatch(SetDepositSuccessPage(true))//提交成功，下一步
                        const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                        if(bonusApplicationMessage){
                            if(bonusResult.toUpperCase() === "SUCCESS"){
                                toastTip.success(bonusApplicationMessage);
                            } else {
                                toastTip.error(bonusApplicationMessage);
                            }
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}

//旧账户
export const SetDepositPayments_OldBank = (data = {}) => {
    return async (dispatch, getState) => {
        const { fileName, fileBytes } = GetUploadFileList() || {}
        const { money } = GetDepositMoneyStatus()
        const { bankName, accountNumber, accountHolderName } = GetDepositMemberBanksActive() || {}
        const { numCode } = GetDepositOldBankSixNumberStatus() || {}
        const { methods } = GetMethodsActive() || {}
        const { language, mgmtRefNo, swiftCode, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        const { transferTypes = [] } = GetMethodsDetails() || {}
        const { enBankName } = GetDepositBankActive() || {}
        toastTip.loading('กำลังโหลด…');
        let postData = {
            // 收款---
            depositingBankAcctNum: numCode || '',
            depositingBankName: enBankName || '',
            province: '',
            city: '',
            branch: '',
            // 收款----

            // 付款---
            bankName: bankName,
            accountNumber: accountNumber || '',
            accountHolderName: accountHolderName || '',
            // 付款---
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            amount: money,
            paymentMethod: methods,
            depositingWallet: depositingWallet,
            offlineDepositDate: `${GetDepositDateSelect()} ${GetDepositTimeSelect()}`,
            language: language,
            charges: 0,
            transactionType: 'Deposit',
            domainName: domainName || '',
            isMobile: false,
            isSmallSet: false,
            refNo: '0',
            swiftCode: swiftCode,
            mgmtRefNo: mgmtRefNo,
            transferType: transferTypes[0] || '',
            offlineRefNo: '0',
            cardName: '',
            cardNumber: '',
            cardPIN: '',
            cardExpiryDate: '',
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            bonusCoupon: '',
            couponText: '',
            successUrl: successUrl,
            fileBytes: fileBytes|| '',
            fileName: fileName|| '',
            secondStepModel: null,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res, true);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    // dispatch(PostConfirmStep(res.result || {}))
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositSuccessPage(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}
export const SetDepositPayments_BQR = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { bankName, accountNumber, accountHolderName } = GetDepositMemberBanksActive() || {}
        const { accountNo, enBankName, province, city, branch } = GetDepositBankActive() || {}
        const { methods } = GetMethodsActive() || {}
        const { language, mgmtRefNo, swiftCode, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        toastTip.loading('กำลังโหลด…');
        let postData = {
            // 收款---
            depositingBankAcctNum: accountNo && accountNo.slice(-6) || '',
            depositingBankName: enBankName || '',
            province: '',
            city: '',
            branch: '',
            // 收款----
            // 付款---
            bankName: bankName,
            accountNumber: accountNumber,
            accountHolderName: accountHolderName,
            // 付款---
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            amount: money,
            paymentMethod: methods,
            depositingWallet: depositingWallet,
            offlineDepositDate: '',
            language: language,
            charges: 0,
            transactionType: 'Deposit',
            domainName: domainName || '',
            isMobile: false,
            isSmallSet: false,
            refNo: '0',
            swiftCode: swiftCode,
            mgmtRefNo: mgmtRefNo,
            transferType: '',
            offlineRefNo: '0',
            cardName: '',
            cardNumber: '',
            cardPIN: '',
            cardExpiryDate: '',
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            bonusCoupon: '',
            couponText: '',
            successUrl: successUrl,
            fileBytes: '',
            fileName: '',
            secondStepModel: null,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}
//EZP存款
export const SetDepositPayments_EZP = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { code } = GetDepositBankActive() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('กำลังโหลด…');
        const postData = {
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: "Deposit",
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet, //目標帳戶
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            bankName: code || '',
            seonSession: await getSeonSession(),
        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}

//TMW存款
export const SetDepositPayments_TMW = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('กำลังโหลด…');
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),

        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}
//CC卡存款
export const SetDepositPayments_CC = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId,toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        const { number } = GetDepositCardNumber_CC()
        const { PIN } = GetDepositCardPIN_CC()
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('กำลังโหลด…');
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            cardNumber: number || '',
            cardPIN: PIN || '',
            refNo: number || '',
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                toastTip.hide()
                sendPiwik(getState, res);
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositSuccessPage(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    let errorMsg = resData?.errors[0]?.description || resData?.errors[0]?.message ||'หมายเลขซีเรียลหรือรหัสผ่านไม่ถูกต้อง'
                    toastTip.error(errorMsg)
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}
//THBQR存款
export const SetDepositPayments_THBQR = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN'} = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('กำลังโหลด…');
        const postData = {
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: "Deposit",
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet, //目標帳戶
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}
//BC存款
export const SetDepositPayments_BC = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { code} = GetDepositBankActive() || {}
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet = 'MAIN' } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}

        toastTip.loading('กำลังโหลด…');
        const postData = {
            bankName: code || '',
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };

        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                sendPiwik(getState, res);
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}

export const SetDepositPayments_CTC = () => {

    return async (dispatch, getState) => {
        const methodCode = GetMethodCodeActive() || {}
        if(methodCode == 'CHANNEL') {
            await dispatch(SetDeposit_CHANNEL())
        } else {
            await dispatch(SetDeposit_CTc())
        }

        const action = {
            type: 'UPLOAD_FILE_LIST_ss',
            data: [],
        };
        return dispatch(action);
    }


}

//CTC充值
export const SetDeposit_CTc = (data = {}) => {
    return async (dispatch, getState) => {
        const { money } = GetDepositMoneyStatus()
        const { language, mgmtRefNo, currencyCode } = PostDepositDefaultDate() || {}
        const { e2Backbox, getSeonSession, successUrl, domainName, siteId, bonusId, bonusRuleGroupId, toastTip, ApiPost, depositingWallet } = GetParamsData() || {}
        const { methods } = GetMethodsActive() || {}
        toastTip.loading('กำลังโหลด…');
        const postData = {
            language: language,
            paymentMethod: methods,
            charges: 0,
            amount: money,
            transactionType: 'Deposit',
            domainName: domainName,
            isMobile: true,
            isSmallSet: false,
            bonusRuleGroupId: bonusRuleGroupId || undefined,
            bonusId: bonusRuleGroupId ? undefined : (bonusId || undefined),
            mgmtRefNo: mgmtRefNo,
            successUrl: successUrl,
            depositingWallet: depositingWallet,
            blackBoxValue: e2Backbox,
            e2BlackBoxValue: e2Backbox,
            methodCode: GetMethodCodeActive() || 'DEFAULT',
            siteId: siteId,
            currencyCode: currencyCode,
            seonSession: await getSeonSession(),
        };


        return ApiPost(PayApiPort.Application, postData)
            .then((res) => {
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}
//虚拟币CHANNEL存款
export const SetDeposit_CHANNEL = (data = {}) => {
    const { code } = GetDepositBankActive() || {}
    const methodsCode = GetMethodCodeActive() || 'CHANNEL'
    const { ApiGet, e2Backbox, successUrl, domainName, siteId, bonusId, toastTip, ApiPost } = GetParamsData() || {}

    return async (dispatch, getState) => {

        toastTip.loading('กำลังโหลด…')
        return ApiGet(`${PayApiPort.CryptocurrencyDetails}coinsCurrency=${code}&methodCode=${methodsCode}&exchangeAmount=1&`)
            .then((res) => {
                toastTip.hide()
                let resData = res || {}
                if (resData.isSuccess) {
                    dispatch({ type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }) //deposit payments dispatch up here due to sequence problem
                    dispatch(SetDepositNextStep(true))//提交成功，下一步
                    const {bonusApplicationMessage, bonusResult} = resData?.result || {};
                    if(bonusApplicationMessage){
                        if(bonusResult.toUpperCase() === "SUCCESS"){
                            toastTip.success(bonusApplicationMessage);
                        } else {
                            toastTip.error(bonusApplicationMessage);
                        }
                    }
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = { type: 'DEPOSIT_PAYMENTS', data: resData.result || {} }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = { type: 'DEPOSIT_PAYMENTS', data: {} }
                return dispatch(action)
            });
    };
}

const sendPiwik = (getState, res, isOld=false) => {
    const { device, webPiwikEvent, appPiwikEvent} = GetParamsData() || {}
    const { methods = '', name = '' } = GetMethodsActive() || {}
    const {DepositTriggerFrom={}, MemberInfo = {}} = getState();
    const {from, vendor} = DepositTriggerFrom;
    const { money } = GetDepositMoneyStatus()

    if (device === 'APP') {
        let vendorPiwikName = vendor?.piwikName || ''
        let data = {
            category: from === "inGame" ? vendorPiwikName : 'Deposit',
            action: from === "inGame" ? `Submit Deposit ${methods}` : (isOld ? `Submit Deposit Old Bank` : `Submit Deposit ${methods}`),
            name: from === "inGame" ? `${vendorPiwikName}_S_${methods}_Deposit` : (isOld ? 'Deposit_Old_Bank_S_Deposit' : `Deposit_${methods}_S_Deposit`),
            path: from === "inGame" ? vendorPiwikName?.toLocaleLowerCase() : `deposit_${methods.toLocaleLowerCase().replace(/\s/g, '_')}`,
            title: from === "inGame" ? vendorPiwikName : `${methods} Deposit Page`,
            isSuccess: res.isSuccess ? 2 : 1,
        }
        if (from === "inGame") {
            if(res.isSuccess) {
                data.customProperties = {
                    [`${vendorPiwikName}_S_${isOld ? 'OldBank' : methods}_Deposit_Amount`]: money || ''
                }
            }
        } else {
            data.customProperties = {
                // [`Deposit_${isOld ? 'OldBank' : name}_S_Deposit_ErrorMsg`]: toastErrMeaasge(res, true),
                [`Deposit_${isOld ? 'OldBank' : methods}_S_Deposit_Amount`]: money
            }
        }
        if (!res.isSuccess) {
            if (from === "inGame") {
                data.customProperties = {
                    [`${vendorPiwikName}_S_${isOld ? 'OldBank' : methods}_Deposit_ErrorMsg`]: toastErrMeaasge(res, true)
                }
            } else {
                data.customProperties = {
                    [`Deposit_${isOld ? 'OldBank' : methods}_S_Deposit_ErrorMsg`]: toastErrMeaasge(res, true),
                }
            }
        }
        appPiwikEvent(data)
    }else{
        try {
            if(device === 'APP') { return }
            if(res.isSuccess){
                const depositedUsers = JSON.parse(localStorage.getItem("isDeposited")) || []
                const isFirstDeposit = !depositedUsers.includes(MemberInfo?.userName) && !Boolean(MemberInfo?.isDeposited)
                if(isFirstDeposit){
                    depositedUsers.push(MemberInfo?.userName)
                    localStorage.setItem("isDeposited", JSON.stringify(depositedUsers))
                    global.sendPropellerAdsConversion && sendPropellerAdsConversion(2);
                }
                global?.fbqTag && fbqTag('rechargeClick');
            }
            if(!isOld){
                webPiwikEvent(
                    from==='deposit' ? `Deposit` : `In${vendor.productCode}`,
                    `Submit Deposit ${methods}`,
                    from==='deposit' ? `Deposit_${methods}_S_Deposit`: `In${vendor.productCode}_S_${methods}_Deposit` ,
                    res.isSuccess ? "2" : "1",
                    [{
                        customVariableKey: res.isSuccess ? (
                            from==='deposit' ? (
                                `Deposit_${methods}_S_Deposit_Amount`
                            ) : (
                                `In${vendor.productCode}_S_${methods}_Deposit_Amount`
                            )
                        ) : (
                            from==='deposit' ? (
                                `Deposit_${methods}_S_Deposit_ErrorMsg`
                             ) : (
                                `In${vendor.productCode}_S_${methods}_Deposit_ErrorMsg`)
                            ),
                        customVariableValue: res.isSuccess ? money : ( res?.errors?.[0]?.description || "กรุณากรอกจำนวนเงินฝาก")
                    }]
                )
            }else{
                webPiwikEvent(
                    from==='deposit' ? `Deposit` : `In${vendor.productCode}`,
                    `Submit Deposit ${methods}`,
                    from==='deposit' ? `Deposit_Old_Bank_S_Deposit`: `In${vendor.productCode}_S_Old_Bank_Deposit` ,
                    res.isSuccess ? "2" : "1",
                    [{
                        customVariableKey: res.isSuccess ? (
                            from==='deposit' ? (
                                `Deposit_Old_Bank_S_Deposit_Amount`
                            ) : (
                                `In${vendor.productCode}_S_Old_Bank_Deposit_Amount`
                            )
                        ) : (
                            from==='deposit' ? (
                                `Deposit_Old_Bank_S_Deposit_ErrorMsg`
                            ): (
                                `In${vendor.productCode}_S_Old_Bank_Deposit_ErrorMsg`
                        )),
                        customVariableValue: res.isSuccess ? money : ( res?.errors?.[0]?.description || "กรุณากรอกจำนวนเงินฝาก")
                    }]
                )
            }


        } catch(e) {
            console.log('Error occurred in DepositPost.sendPiwik ', e)
        }
    }
}
